module.exports = __webpack_public_path__ + "static/media/greenMail.37d2e88d.svg";